export default {
  channel: '52bjd_web',

  gameId: 1150,

  signLoginKey: 'pdka07bdb96c165062fea06a7d39401f5e1pdk',
  signKey: 'aeafdc6fe1f8268a94d31a4f5208c2df',
  payApiKey: 'dfc2c2d62dde2c104203cf71c6e15580',

  /**
   * @description api请求基础路径
   */
  apiDomainConfig: {
    dev: {
      baseUrl: 'https://testapi.52bjd.com',
      payUrl: 'https://testapi.52bjd.com',
      actmUrl: 'https://testapi.52bjd.com'
    },
    pro: {
      baseUrl: 'https://cfg.52bjd.com',
      payUrl: 'https://paym.52bjd.com/pay',
      actmUrl: 'https://actm1.52bjd.com/activity'
    }
  },
  resourceMap: {
    0: '金币',
    1: '白金点',
    2: '道具',
    3: '礼券'
  }
}



// WEBPACK FOOTER //
// ./src/config/index.js